import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import HostingPage from "./pages/HostingPage";
import PlanRecommender from "./pages/PlanRecommender";
import DomainsPage from "./pages/DomainsPage";
import Contact from "./pages/Contact";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import ReferEarn from "./pages/ReferEarn";
import GpuCloud from "./pages/GpuCloud";
import GpuDetail from "./pages/GpuDetail";
import AdminLogin from "./admin/AdminLogin";
import AdminDashboard from "./admin/AdminDashboard";
import WhatsAppButton from "./components/WhatsAppButton";
import FloatingActions from "./components/FloatingActions";
import Security from "./pages/Security";
import Solutions from "./pages/Solutions";
import BaasDraas from "./pages/BaasDraas";
import Compare from "./pages/Compare";
import TopBar from "./components/TopBar";
import { Toaster } from "sonner";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

const MainLayout = ({ children }) => (
  <>
    <TopBar />
    <Navbar />
    <main>{children}</main>
    <Footer />
  </>
);

function App() {
  return (
    <div className="App" style={{ background: "#030305", minHeight: "100vh" }}>
      <BrowserRouter>
        <ScrollToTop />
        <Toaster theme="dark" position="top-right" richColors />
        <WhatsAppButton />
        <FloatingActions />
        <Routes>
          <Route path="/" element={<MainLayout><Home /></MainLayout>} />
          <Route path="/vps-hosting" element={<MainLayout><HostingPage category="vps" /></MainLayout>} />
          <Route path="/shared-hosting" element={<MainLayout><HostingPage category="shared" /></MainLayout>} />
          <Route path="/cloud-hosting" element={<MainLayout><HostingPage category="cloud" /></MainLayout>} />
          <Route path="/gpu-cloud" element={<MainLayout><GpuCloud /></MainLayout>} />
          <Route path="/gpu/:card" element={<MainLayout><GpuDetail /></MainLayout>} />
          <Route path="/domains" element={<MainLayout><DomainsPage /></MainLayout>} />
          <Route path="/ssl" element={<MainLayout><HostingPage category="ssl" /></MainLayout>} />
          <Route path="/email-hosting" element={<MainLayout><HostingPage category="email" /></MainLayout>} />
          <Route path="/plan-recommender" element={<MainLayout><PlanRecommender /></MainLayout>} />
          <Route path="/contact" element={<MainLayout><Contact /></MainLayout>} />
          <Route path="/blog" element={<MainLayout><Blog /></MainLayout>} />
          <Route path="/blog/:slug" element={<MainLayout><BlogPost /></MainLayout>} />
          <Route path="/refer" element={<MainLayout><ReferEarn /></MainLayout>} />
          
          {/* Enterprise Routes */}
          <Route path="/security" element={<MainLayout><Security /></MainLayout>} />
          <Route path="/solutions" element={<MainLayout><Solutions /></MainLayout>} />
          <Route path="/baas-draas" element={<MainLayout><BaasDraas /></MainLayout>} />
          <Route path="/compare" element={<MainLayout><Compare /></MainLayout>} />

          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
